/** Sales Move — computed Home command-queue view model (not a CRM entity store). */
export const SALES_MOVE_BUCKET_LABELS = {
    ACT_NOW: "Act Now",
    REPLY_NEEDED: "Reply Needed",
    READY_TO_ADVANCE: "Ready to Advance",
    AT_RISK: "At Risk",
    WAITING: "Waiting",
    NURTURE: "Nurture",
    ALL_ACTIVE: "All Active",
};
export const SALES_MOVE_TYPE_LABELS = {
    REPLY: "Reply",
    CALL: "Call",
    EMAIL: "Email",
    ADVANCE: "Advance",
    PREPARE_PROPOSAL: "Prepare proposal",
    REVIEW_PROPOSAL: "Review proposal",
    ADD_STAKEHOLDER: "Add stakeholder",
    RESOLVE_BLOCKER: "Resolve blocker",
    DELEGATE: "Delegate",
    WAIT: "Wait",
    NURTURE: "Nurture",
    CLOSE: "Close",
    CORRECT_DATA: "Correct data",
};
export const SALES_MOVE_PRIORITY_LABELS = {
    critical: "Critical",
    high: "High",
    normal: "Normal",
    low: "Low",
};
export const NOT_RIGHT_REASONS = [
    "Already handled",
    "Wrong recommendation",
    "Incorrect information",
    "Not important enough",
    "Wrong timing",
    "Wrong owner",
    "No human action required",
];
export const GENERATION_VERSION = 1;
/** Confidence below this threshold does not emit a move. */
export const SALES_MOVE_CONFIDENCE_THRESHOLD = 0.55;
export const FOCUSED_QUEUE_DEFAULT_LIMIT = 7;
export const MOBILE_QUEUE_DEFAULT_LIMIT = 5;
//# sourceMappingURL=sales-move.js.map